import { Typography } from "@material-ui/core"

const Rights = (props) => {

  return ( <>
    <Typography>
      We do! We retain the rights to all songs we create, which allows us to feature them in our portfolio or promotional materials. That said, it’s your song to use however you’d like for personal occasions—weddings, proposals, anniversaries, or just playing on repeat because it’s <i>that</i> good. If you ever want to use it commercially, just reach out, and we can discuss a licensing agreement!
    </Typography>
  </> )
}

export default Rights
